import React from 'react';
import './help-links.less';
import { getLocalizedHref } from '../../utils/get-localized-url';

const HELP_LINKS = {
    contactSupport: {
        text: 'Contact Atlassian support',
        href: 'https://support.atlassian.com/contact'
    },
    community: {
        text: 'Atlassian Community',
        href: 'https://community.atlassian.com/'
    },
    developerCommunity: {
        text: 'Atlassian Developer Community',
        href: 'https://community.developer.atlassian.com/'
    },
    developerSupportDesk: {
        text: 'Developer Support Service Desk',
        href: 'https://ecosystem.atlassian.net/servicedesk/customer/portal/14'
    },
    connectWithPartner: {
        text: 'Atlassian Partner',
        href: 'https://www.atlassian.com/partners'
    }
};

const HelpLinks = () => {
    const [localizedLinks, setLocalizedLinks] = React.useState(HELP_LINKS);

    React.useEffect(() => {
        // create an object from HELP_LINKS with localized hrefs
        const localized = Object.fromEntries(
            Object.entries(HELP_LINKS).map(([key, value]) => [
                key,
                {
                    ...value,
                    href: getLocalizedHref(value.href)
                }
            ])
        );
        // set the localized links state
        setLocalizedLinks(localized as typeof HELP_LINKS);
    }, []);

    return (
        <div className="help-links">
            <p className="help-links__lead-in">More ways to get help</p>
            <p>
                <a href={localizedLinks.contactSupport.href}>
                    {localizedLinks.contactSupport.text}
                </a>
            </p>
            <p>
                Visit the{' '}
                <a href={localizedLinks.community.href}>
                    {localizedLinks.community.text}
                </a>{' '}
                or
                <a href={localizedLinks.developerCommunity.href}>
                    {' '}
                    {localizedLinks.developerCommunity.text}
                </a>
            </p>
            <p>
                Contact the{' '}
                <a href={localizedLinks.developerSupportDesk.href}>
                    {localizedLinks.developerSupportDesk.text}
                </a>
            </p>
            <p>
                Connect with an{' '}
                <a href={localizedLinks.connectWithPartner.href}>
                    {localizedLinks.connectWithPartner.text}
                </a>{' '}
                for custom requests
            </p>
        </div>
    );
};

export default HelpLinks;
